import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PinUserIcon from 'Assets/Images/icons/pinUser'
import { PATHS } from 'Config/Routing/paths'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { AmbassadorWrapper } from 'Components/City/Page/Ambassador/AmbassadorWrapper'
import { PageTitle } from 'Components/PageTitle'
import * as CONST from 'Reducers/Ambassador/const'
import { getCities } from 'Reducers/City/actions'
import { getClients } from 'Reducers/Clients/actions'
import LegalDocumentsSection from '../../Ambasador/Components/LegalDocumentsSection/container/LegalDocumentsSection'
import ContactDetailsSection from '../Components/ContactDetailsSection'
import IdentificationFilesSection from '../Components/IdentificationFilesSection'
import ActivitySection from '../Components/ActivitySection'
import BankDetailsSection from '../Components/BankDetailsSection'
import { updateAmbassadorByIdGraphQL } from '../../../../../Reducers/Ambassador/actions'
import { getSpy, getSpyActivity } from '../gql'
import { normalizeGraphQLConnection } from '../../../../../shared/graphql/utils'
import {
  hideReduxModal,
  resetReduxModal,
  showReduxModal,
} from '../../../../../Reducers/UI/actions'
import { deleteSpyShift } from '../../MasterSchedule/gql'
import { Box } from '@material-ui/core'
import useGraphQLFetch from '../../../../../Utils/Hooks/useGraphQLFetch'
import { refuseUser, updateUserDocument } from '../../Ambasador/gql'
import { getDocumentTypes } from 'Reducers/Document/actions'
import { authorization } from '../../../../../Module/Auth/Auth'
import StyledBreadcrumbs from '../../../../../Components/StyledBreadcrumbs'
import { theme } from '../../../../../Assets/Styles/theme'

const SpyPage = props => {
  const { match } = props
  const {
    url,
    params: { spyId },
  } = match
  const [isSpyUpdating, setIsSpyUpdating] = useState(false)
  const [missions, setMissions] = useState([])
  const [isMissionsLoaded, setIsMissionsLoaded] = useState(false)
  const [documents, setDocuments] = useState([])
  const [nmbrsDocument, setNmbrsDocument] = useState([])
  const [spyData, setSpyData] = useState(null)

  const dispatch = useDispatch()

  const cities = useSelector(state => state.city.citiesList)

  const { data: spy, isLoaded, refetch } = useGraphQLFetch({
    fetchFn: getSpy,
    defaultFetchArgs: { id: spyId },
    mapResponse: data => {
      data.spy.signedLegalDocuments = data.spy.signedLegalDocuments.edges.map(
        e => ({
          dateTime: e.node.dateTime,
          name: e.node.legalDocument.name,
          url: e.node.legalDocument.url,
        }),
      )

      return data.spy
    },
  })

  const user = authorization.getUser()
  const logsParams = type => ({
    input: {
      profile_user_id: +spyId,
      actioned_by_user_id: +user.id,
      type,
    },
  })

  useEffect(() => {
    dispatch(getDocumentTypes())
    getSpyActivities()
    dispatch(getCities(true))
    dispatch(getClients())
  }, [])

  useEffect(() => {
    if (isLoaded && spy) {
      setSpyData(spy)
      setIsSpyUpdating(false)
    }
  }, [isLoaded])

  useEffect(() => {
    let documentTypes
    if (!spyData) return
    if (spyData && spyData.city && documentTypesList.length > 0) {
      const filteredList = documentTypesList.filter(
        doc =>
          doc.countryCode == spyData.city.country.code &&
          doc.active &&
          !doc.ignoredCities.includes(Number(spyData.city.id)),
      )
      documentTypes = filteredList
    }
    const userDocuments = spyData.documents.nodes

    if (documentTypes && documentTypes.length > 0) {
      const documentsList = documentTypes.map(docType => {
        const userDocument = userDocuments.find(
          doc => Number(docType.id) == Number(doc.documentTypeId),
        )
        const uploader =
          userDocument && userDocument.uploader
            ? userDocument.uploader
            : spy.email
        return {
          ...userDocument,
          name: docType.name,
          uploader: userDocument ? uploader : null,
        }
      })
      setDocuments(documentsList)
    }
  }, [spyData])

  const documentTypesList = useSelector(
    state => state.document.documentTypesList,
  )

  const getSpyActivities = async () => {
    setIsMissionsLoaded(false)
    setMissions([])
    let fetchArgs = { spyId, first: 50 }
    const { data } = await getSpyActivity(fetchArgs)

    let spyActivities = normalizeGraphQLConnection(data.spy.missions)
    let pageInfo = data.spy.missions.pageInfo
    while (pageInfo.hasNextPage) {
      fetchArgs.after = pageInfo.endCursor
      const { data: newData } = await getSpyActivity(fetchArgs)
      pageInfo = newData.spy.missions.pageInfo

      spyActivities = [
        ...spyActivities,
        ...normalizeGraphQLConnection(newData.spy.missions),
      ]
    }

    setMissions(spyActivities)
    setIsMissionsLoaded(true)
  }

  const statusHTML = () => {
    let statusID = status

    if (!spy) {
      return null
    }

    return (
      status && (
        <span className="status">
          ({CONST.AMBASSADOR_STATUS_LABEL[statusID]})
        </span>
      )
    )
  }

  if (!spy) {
    return null
  }

  const { id, city, firstName, lastName, status, isNewcomer } = spy

  const userName = `${firstName} ${lastName}`

  const spyPathname = `${PATHS.main.dashboard}${PATHS.dashboard.cities}/${
    city.id
  }/spy`

  async function handleUserActions({ status, blockedReason, unbookMissions }) {
    setIsSpyUpdating(true)
    await dispatch(
      updateAmbassadorByIdGraphQL(
        spyId,
        {
          statusV2: status,
          blockedReason,
          unbookMissions,
        },
        {
          onSuccess: () => {
            refetch({ id: spyId })
            if (unbookMissions) {
              getSpyActivities()
            }
          },
        },
      ),
    )
  }

  const deleteMission = mission => {
    dispatch(
      showReduxModal({
        title: 'Confirmation needed',
        children: (
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            mt={3}
            mb={3}
          >
            Spy will be removed from the whole shift
          </Box>
        ),
        onConfirm: async () => {
          try {
            await deleteSpyShift(
              {
                id: mission.spyInformation.shift.id,
              },
              { doNotShowErrorModal: true },
            )
            await getSpyActivities()
            hideReduxModal()
            resetReduxModal()
          } catch (error) {
            hideReduxModal()
            resetReduxModal()
            alert(`Error occured: ${error.message}`)
          }
        },
        onCancel: () => {
          hideReduxModal()
          resetReduxModal()
        },
      }),
    )
  }

  if (!id) return null

  const onDocumentUpdate = async input => {
    try {
      await updateUserDocument({ input })
    } catch (error) {
      /* eslint-disable */
      console.log({ error })
    }
  }

  const onRefuse = async () => {
    await refuseUser({ input: { id: spy.id } })
    refetch({ id: spyId })
  }

  const breadcrumbs = [
    { label: 'Dashboard', link: PATHS.main.dashboard },
    {
      label: 'Cities',
      link: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
    },
    {
      label: city.name,
      link: `${PATHS.main.dashboard}${PATHS.dashboard.cities}/${
        city ? city.id : null
      }${PATHS.cities.masterSchedule}`,
    },
    { label: 'Spies', link: spyPathname },
    {
      label: `${firstName} ${lastName}`,
      link: url,
    },
  ]

  return (
    <HideWhenBlocked>
      <AmbassadorWrapper>
        <StyledBreadcrumbs
          icon={
            <PinUserIcon style={{ width: 16, fill: theme.colors.primary }} />
          }
          breadcrumbs={breadcrumbs}
        />
        <PageTitle>
          {userName}
          {statusHTML()}
          {isNewcomer && (
            <div
              style={{ float: 'right', lineHeight: '34px', fontSize: '16px' }}
            >
              <span role="img" aria-label="warning">
                ⚠️
              </span>
              Newcomer
              <span role="img" aria-label="warning">
                ⚠️
              </span>
            </div>
          )}
        </PageTitle>
        <div>
          <ContactDetailsSection
            ambassadorId={spyId}
            ambassador={spy}
            cities={cities}
            isSpyUpdating={isSpyUpdating}
            handleUserActions={handleUserActions}
            documents={documents}
            nmbrsDocument={nmbrsDocument}
            onRefuse={onRefuse}
          />
          <IdentificationFilesSection
            ambassador={spy}
            cities={cities}
            documentTypesList={documentTypesList}
            updateUserDocument={onDocumentUpdate}
            documents={documents}
            setDocuments={setDocuments}
            nmbrsDocument={nmbrsDocument}
            setNmbrsDocument={setNmbrsDocument}
            user={user}
          />
          {!authorization.isCityManagerAssistant() ? (
            <BankDetailsSection ambassador={spy} logsParams={logsParams} />
          ) : null}
          <LegalDocumentsSection
            signedLegalDocuments={spy.signedLegalDocuments || []}
            formW9={spy.formW9}
            timezone={spy.city.timezone}
          />
          <ActivitySection
            match={match}
            missions={missions}
            isLoaded={isMissionsLoaded}
            deleteMission={deleteMission}
          />
        </div>
      </AmbassadorWrapper>
    </HideWhenBlocked>
  )
}

export default withRouter(SpyPage)
